
import { Injectable, Inject} from '@angular/core';
import {BaseDO} from './base.model';



 export abstract class BasePolicyPaymentDO extends BaseDO {

    public  paymentMethodCd:string;
    public  paymentFrequencyCd:string;
    public  accountNumber:string;
    public  accountHolderName:string;

 }